var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    ref: "sidebar",
    attrs: {
      id: "sidebar-estimate",
      title: _vm.estimate
        ? _vm.$t("Confirmar solicitação de entrega")
        : _vm.$t("Cotação de entrega"),
      show: _vm.showSidebar,
      fetching: _vm.fetching,
      saving: _vm.saving,
      "confirm-button-text": _vm.$t("Solicitar entrega"),
      "hide-save-button": !_vm.estimate || _vm.fetching,
      width: "40%",
    },
    on: { hidden: _vm.hide, save: _vm.localCreateDeliveryOrder },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c("p", { staticClass: "h6 mb-1" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Parceiro de entrega")) + " "),
                    ]),
                    _vm.deliverySupplierOptions.length
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex flex-wrap",
                            staticStyle: { gap: "8px" },
                          },
                          _vm._l(
                            _vm.deliverySupplierOptions,
                            function (option) {
                              return _c("e-button", {
                                key: option.value,
                                attrs: {
                                  id:
                                    "delivery-estimate-sidebar_supplier-" +
                                    option.value,
                                  text: option.label,
                                  icon: "cash",
                                  variant:
                                    option.value ===
                                    _vm.selectedDeliverySupplier
                                      ? "primary"
                                      : "outline-primary",
                                  disabled:
                                    _vm.fetching || _vm.loadingSuppliers,
                                  busy:
                                    _vm.fetching &&
                                    option.value ===
                                      _vm.selectedDeliverySupplier,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAndQuote(option.value)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-alert",
                      {
                        staticClass: "mb-1 mt-1",
                        attrs: {
                          variant: "warning",
                          show:
                            !_vm.loadingSuppliers &&
                            !_vm.deliverySupplierOptions.length,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Nenhum parceiro de entrega cadastrado.")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-alert",
                      {
                        staticClass: "mb-1 mt-1",
                        attrs: {
                          variant: "danger",
                          show: !!_vm.validationMessage,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.validationMessage) + " ")]
                    ),
                    _c(
                      "b-alert",
                      {
                        staticClass: "mt-1 mb-0",
                        attrs: {
                          variant: "warning",
                          show: !!_vm.cotacaoErrorMessage,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.cotacaoErrorMessage) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.order && _vm.estimate
              ? _c(
                  "b-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-col",
                      [
                        _c("FormulateInput", {
                          attrs: {
                            value:
                              "#" +
                              _vm.localOrder.id +
                              " - " +
                              _vm.localOrder.customer.name,
                            type: "label",
                            label: _vm.$t("Pedido"),
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value:
                              _vm.estimate.supplier &&
                              _vm.estimate.supplier.name
                                ? _vm.estimate.supplier.name
                                : _vm.selectedSupplierLabel || "-",
                            type: "label",
                            label: _vm.$t("Serviço de entrega"),
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value:
                              _vm.store.address.publicPlace +
                              ", " +
                              _vm.store.address.number +
                              " - " +
                              _vm.store.address.neighborhood,
                            type: "label",
                            label: _vm.$t("Local de retirada"),
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value:
                              _vm.localOrder.deliveryAddress.publicPlace +
                              ", " +
                              _vm.localOrder.deliveryAddress.number +
                              " - " +
                              _vm.localOrder.deliveryAddress.neighborhood,
                            type: "label",
                            label: _vm.$t("Local de entrega"),
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value:
                              _vm.estimate.deliveryDistance / 1000 +
                              " km / " +
                              _vm.estimate.deliveryDuration +
                              " min",
                            type: "label",
                            label: _vm.$t("Distância / Tempo de entrega"),
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value: _vm.estimate.fee / 100,
                            type: "label",
                            label: _vm.$t("Valor estimado"),
                            currency: _vm.$t("R$"),
                            filter: "currency",
                            "currency-symbol-position": "prefix",
                            precision: 2,
                          },
                        }),
                        _c("FormulateInput", {
                          attrs: {
                            value: new Date(_vm.estimate.expiresTime * 1000),
                            type: "label",
                            label: _vm.$t("Expira em"),
                            filter: "datetime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }